module.exports = __webpack_public_path__ + "img/bg07.212ec12c.png";